module.exports = __webpack_public_path__ + "static/letterpress-5e0dd5f627b252321efca9d505b5d743.jpg";